<template>
  <el-carousel :height="height+'px'" :interval="3000" arrow="always" @click.native="linkTo">
    <el-carousel-item v-for="item in hotList" :key="item">
      <div class="b-banner-item_en clearfix">
        <a :href="item.url">
        <img class="b-banner-img_en" :src="item.IP_URL + '/ueditor/images/' + item.slidePicture" width="100%"/>
        <div class="b-info_en clearfix">
          <div class="b-title_en">
            {{ item.title }}
          </div>
        </div>
        </a>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  import Header from "@/components/header/en/";
  import $ from "jquery";

  export default {
    data() {
      return {
        hotList: [],
        height: 0
      };
    },
    mounted() {
      var self = this;
      self.height = window.screen.height - 235;
      console.log("height is: "+self.height);
      $.ajax({
        url: Header.IP_URL + '/news/hotList?l=en',
        type: 'get',
        // data: {},
        dataType: 'json'
      }).then(function (res) {
        console.log(res);
        // 把从json获取的数据赋值给数组
        self.hotList = res.data;
        for(var i=0; i < self.hotList.length; i++){
          if(self.hotList[i].hotType =='news') {
            self.hotList[i].url = '/detail/en?type=news&id=' + self.hotList[i].hotId;
            self.hotList[i].IP_URL = Header.IP_URL;
          } else if(self.hotList[i].hotType =='notice') {
            self.hotList[i].url = '/detail/en?type=notice&id=' + self.hotList[i].hotId;
            self.hotList[i].IP_URL = Header.IP_URL;
          } else if(self.hotList[i].hotType =='activitys') {
            self.hotList[i].url = '/detail/en?type=activitys&id=' + self.hotList[i].hotId;
            self.hotList[i].IP_URL = Header.IP_URL;
          }
        }
      }).fail(function () {
        console.log('失败');
      });
    },
    linkTo() {
      console.log('aaaa');
      let activeIndex = this.$refs.carousel.activeIndex;
      console.log(activeIndex);
      if(this.hotList[activeIndex].hotType =='news') {
        this.hotList[activeIndex].url = '/detail/en?type=news&id=' + this.hotList[activeIndex].hotId;
        this.hotList[i].IP_URL = Header.IP_URL;
      } else if(this.hotList[activeIndex].hotType =='activitys'){
        this.hotList[activeIndex].url = '/detail/en?type=activitys&id=' + this.hotList[activeIndex].hotId;
        this.hotList[i].IP_URL = Header.IP_URL;
      }
      this.$router.push(this.hotList[activeIndex].url);
    }
  };
</script>

<style lang="scss">
.b-banner-item_en{
  //position: relative;
  //height:calc(100% - 134px);
  .b-banner-img_en{
    position: relative;
    z-index: 1;
  }
  .b-info_en{
    width: 100%;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    background: rgba(0,0,0,0.5);
    z-index: 10;
    .b-title_en{
      color: #fff;
      font-size: 16px;
      line-height: 28px;
      text-align: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slider/en/index.vue